import Select from "react-select";

const ReUsableSelect = ({
  label,
  instanceId,
  onChange,
  options,
  value,
  placeholder,
  formLoading,
  styles,
}: any) => {
  return (
    <div className="d-flex flex-column gap-2">
      <div className="fs-5">
        {label}
        <span className="text-danger">*</span>
      </div>
      <Select
        isClearable
        isSearchable
        instanceId={instanceId}
        onChange={onChange}
        options={options}
        value={value}
        placeholder={placeholder}
        isDisabled={formLoading}
        styles={styles}
      />
    </div>
  );
};

export default ReUsableSelect;
